import React from 'react'
import { SettingsDialog } from './SettingsDialog';

export const Settings: React.FC<SettingProps> = (props) => {

    return (
        <>
            {
                props.showPopup && <SettingsDialog onSaved={() => { props.popupToggled(false) }} onClose={() => { props.popupToggled(false) }} />
            }

        </>)
}

export type SettingProps = {
    popupToggled: (visible) => void
    showPopup: boolean
    badgeCount: number
}